const pathwayTypes = {
  GRAPH: 'GRAPH',
  LINEAR: 'LINEAR',
  FREE: 'FREE',
};

export default pathwayTypes;
